const pro = {
  path: 'https://testapi.growup.link'
}
module.exports = pro



// WEBPACK FOOTER //
// ./src/config/testpro.js